import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ContentStoreSelectors, ContentStoreState } from '@nrwl/rx-state-content';

@Pipe({ name: 'getCategoryItems' })
export class GetCategoryItemsPipe implements PipeTransform {
  constructor(private store: Store<ContentStoreState.ContentState>) {}

  transform(category: any, searchType: any) {
    return this.store.pipe(
      select(ContentStoreSelectors.getCategoryItems, {
        category: category,
        searchType: searchType,
      }),
    );
  }
}
